/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function AIChangeTone({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g stroke="currentColor" strokeWidth={1.2} clipPath="url(#AIChangeTone_svg__a)"><path strokeLinecap="round" d="M7.594 12.504V15" /><rect width={4.25} height={8.339} x={5.469} y={1.75} strokeLinejoin="round" rx={2} /><path strokeLinecap="round" strokeLinejoin="round" d="M3.25 7.875v.285c0 2.399 1.944 4.344 4.344 4.344v0c2.399 0 4.344-1.945 4.344-4.344v-.285" /><path strokeLinecap="round" d="M1.125 15.444h13.75" /></g><defs><clipPath id="AIChangeTone_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;